<div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">
  <div [ngClass]="[item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].isEdited? 'edited-cell':'grid-cell-ellipsis',
  true?'grid-cell-ellipsis':'grid-cell-ellipsis',
  item.cells[fieldDefinition.key+'Color'] && item.cells[fieldDefinition.key+'Color'].value ? item.cells[fieldDefinition.key+'Color'].value:'']"
       matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}"
  >
    {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
  </div>
  <button (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
    <mat-icon>create</mat-icon>
  </button>
</div>
